import { Button, Card, Input, Table, Tag } from "antd";
import Loading from "../common/Loading";
import { ColumnsType } from "antd/lib/table";
import { useLocationStatusList } from "./index.hook";
import { LocationStatusRecord } from "../../shared/interface/locationStatusList.interface";
import { TableHelper } from "../../util/TableHelper";

const LocationStatusList = () => {
  const config = useLocationStatusList();

  const columns: ColumnsType<LocationStatusRecord> = [
    {
      align: "left",
      title: "Sr No.",
      dataIndex: "sr_no",
      key: "sr_no",
      render: TableHelper.renderNumberValue,
      sorter: {
        compare: TableHelper.valueCompare("sr_no")
      },
      width: "5%"
    },
    {
      align: "left",
      title: "Customer",
      dataIndex: "customer_name",
      key: "customer_name",
      render: TableHelper.renderText,
      sorter: {
        compare: TableHelper.valueCompare("customer_name")
      }
    },
    {
      align: "left",
      title: "Location",
      key: "location_name",
      dataIndex: "location_name",
      render: TableHelper.renderText,
      sorter: {
        compare: TableHelper.valueCompare("location_name")
      }
    },
    {
      align: "left",
      title: "Device Id",
      dataIndex: "device_id",
      key: "device_id",
      render: TableHelper.renderText,
      sorter: {
        compare: TableHelper.valueCompare("device_id")
      }
    },
    {
      align: "center",
      title: "Gateway Status",
      dataIndex: "gatewayStatus",
      key: "gatewayStatus",
      render: (text) => (
        <Tag className="gx-text-center gx-m-0" color={config.getStatusColor(text)}>
          {text}
        </Tag>
      ),
      sorter: {
        compare: TableHelper.valueCompare("gatewayStatus")
      }
    },
    {
      align: "center",
      title: "PLC Status",
      dataIndex: "plcStatus",
      key: "plcStatus",
      render: (text) => (
        <Tag className="gx-text-center gx-m-0" color={config.getStatusColor(text)}>
          {text}
        </Tag>
      ),
      sorter: {
        compare: TableHelper.valueCompare("plcStatus")
      }
    },

    {
      align: "center",
      title: "Last Device To Cloud Time",
      dataIndex: "lastIotHubLogTime",
      key: "lastIotHubLogTime",
      render: TableHelper.renderText,
      sorter: {
        compare: TableHelper.dateSorter("lastIotHubLogTime")
      }
    }
  ];

  return (
    <Card
      className="gx-card card--height"
      title={
        <div className={`gx-title-container`}>
          <Button onClick={config.handleRefreshList} className={`button-gradiant gx-mb-0 add-button`} loading={config.loading}>
            Refresh
          </Button>
          <Input.Search className={`gx-mb-0 search-component__width`} allowClear placeholder={`Search...`} value={config.searchedText} onChange={(e) => config.handleChangeOnSearch(e.target.value)} onSearch={config.handleChangeSearch} />
        </div>
      }
    >
      {config.loading ? <Loading /> : <Table className="gx-table-responsive" size="small" columns={columns} dataSource={config.locationList} pagination={config?.pagination} bordered onChange={config.handleChangePagination} rowKey={(record) => record.sr_no} />}
    </Card>
  );
};

export default LocationStatusList;
